import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { orange, green, red, blue } from '@mui/material/colors';


const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const variantIconColor = {
    success: green[500],
    warning: orange[500],
    error: red[500],
    info: blue[500],
};

const EmptyStateLabel = ({ ...props }) => {
    const { text, icon = "info", style, infoText } = props;


    const Icon = icon ? variantIcon[icon] : null;
    const iconColor = icon ? variantIconColor[icon] : null;

    return (
        <div style={{ flex: '1 1 auto', padding: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', ...style }}>
            {Icon &&
                <Icon sx={{ fontSize: 45, opacity: 0.9, marginBottom: 2, color: iconColor }} />
            }
            <Typography variant="subtitle1" align="center">{text}</Typography>
            {infoText &&
                <Typography variant="caption" align="center" style={{ marginTop: 8 }}>{infoText}</Typography>
            }
        </div>
    )
}

EmptyStateLabel.propTypes = {
    text: PropTypes.node.isRequired,
    infoText: PropTypes.node,
    icon: PropTypes.oneOf(["info", "error", "warning", "success"]),
};

EmptyStateLabel.displayName = "EmptyStateLabel";

export default EmptyStateLabel;